import React, { FC, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<SVGSVGElement> {
  className?: string;
  size?: number;
  color?: string;
}

export const CloseIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
    </svg>
  );
};
